function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M9.601,18.022c-1.119,4.742-1.262,5.488-1.406,6.306H8.171c-0.191-1.116-0.277-1.573-1.285-6.306h-1.91 c-0.914,4.527-1.045,5.404-1.201,6.306H3.752c-0.156-0.985-0.266-1.586-1.371-6.306h-1.92l2.438,8.624H4.58 c0.926-4.444,1.068-5.069,1.334-6.727h0.023c0.287,1.656,0.445,2.498,1.334,6.727H9l2.428-8.624H9.601z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M7.951,30.962c0-0.767-0.183-0.892-0.521-1.039c0.406-0.139,0.635-0.526,0.635-0.979c0-0.352-0.199-1.16-1.291-1.16H4.698 v4.103H5.54v-1.605h0.885c0.635,0,0.67,0.216,0.67,0.777c0,0.424,0.033,0.635,0.09,0.828h0.949V31.78 C7.952,31.713,7.952,31.565,7.951,30.962z M6.544,29.594H5.54v-1.1h1.068c0.502,0,0.6,0.32,0.6,0.537 C7.208,29.438,6.991,29.594,6.544,29.594z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "0.849,27.786 0.85,28.512 2.09,28.512 2.09,31.889 2.945,31.889 2.945,28.512 4.186,28.512 4.186,27.786 \t\t"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M22.335,5.659c-0.021-0.362-0.034-0.569-0.034-0.569s-0.031,0.205-0.09,0.564c-0.025,0.177-0.062,0.392-0.102,0.639 c-0.029,0.246-0.148,0.509-0.229,0.799c-0.084,0.29-0.186,0.598-0.354,0.898c-0.155,0.304-0.293,0.63-0.528,0.917 c-0.104,0.147-0.211,0.297-0.317,0.449c-0.113,0.146-0.259,0.273-0.387,0.411c-0.247,0.286-0.55,0.52-0.851,0.75 c-0.284,0.242-0.642,0.409-0.942,0.609c-0.347,0.151-0.651,0.337-0.993,0.449c-0.326,0.13-0.648,0.241-0.965,0.322 c-0.306,0.1-0.613,0.148-0.884,0.214c-0.173,0.031-0.333,0.057-0.486,0.08c0.015-0.047,0.034-0.091,0.05-0.138 c0.145-0.438,0.254-0.896,0.326-1.377c0.03-0.244,0.055-0.491,0.072-0.743c0.014-0.255,0.009-0.52-0.017-0.796 c-0.257,0.107-0.492,0.228-0.713,0.357c-0.214,0.133-0.42,0.271-0.621,0.414c-0.392,0.289-0.745,0.6-1.064,0.932 c-0.645,0.661-1.171,1.394-1.609,2.179l-0.056,0.097c-0.27,0.488-0.217,1.113,0.177,1.551c0.52,0.577,1.09,1.114,1.752,1.573 c0.329,0.231,0.681,0.444,1.064,0.633c0.383,0.187,0.778,0.365,1.248,0.479c-0.024-0.482-0.122-0.905-0.23-1.317 c-0.106-0.401-0.244-0.776-0.403-1.136c0.351-0.114,0.775-0.272,1.254-0.475c0.309-0.148,0.648-0.286,0.988-0.483 c0.346-0.178,0.696-0.393,1.049-0.631c0.361-0.217,0.694-0.522,1.047-0.787c0.318-0.319,0.668-0.601,0.949-0.961 c0.291-0.347,0.573-0.693,0.789-1.083c0.11-0.19,0.236-0.367,0.328-0.562C21.636,9.72,21.72,9.526,21.8,9.334 c0.184-0.37,0.262-0.765,0.354-1.125c0.109-0.356,0.145-0.705,0.166-1.025s0.076-0.605,0.055-0.863 C22.357,6.066,22.348,5.842,22.335,5.659z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M20.204,2.806c-0.503-0.592-1.057-1.146-1.705-1.625c-0.322-0.242-0.667-0.465-1.044-0.665 C17.076,0.319,16.685,0.13,16.22,0c0.009,0.483,0.094,0.908,0.191,1.324c0.095,0.404,0.222,0.783,0.37,1.147 c-0.355,0.104-0.785,0.25-1.268,0.438c-0.314,0.139-0.657,0.266-1.002,0.453c-0.351,0.168-0.708,0.372-1.068,0.6 c-0.367,0.207-0.709,0.501-1.068,0.755c-0.328,0.31-0.687,0.58-0.978,0.933c-0.3,0.338-0.594,0.675-0.821,1.059 c-0.116,0.187-0.248,0.36-0.345,0.551c-0.091,0.194-0.179,0.387-0.266,0.575C9.77,8.199,9.682,8.591,9.579,8.948 c-0.12,0.353-0.164,0.7-0.196,1.02c-0.028,0.319-0.095,0.602-0.079,0.861c0.008,0.256,0.015,0.479,0.02,0.663 c0.012,0.362,0.016,0.57,0.016,0.57s0.038-0.205,0.105-0.562c0.033-0.176,0.074-0.389,0.12-0.635 c0.038-0.245,0.164-0.505,0.253-0.792c0.094-0.288,0.202-0.593,0.383-0.887c0.164-0.3,0.312-0.622,0.555-0.902 c0.109-0.143,0.22-0.29,0.332-0.438c0.117-0.144,0.266-0.266,0.396-0.4c0.253-0.277,0.563-0.502,0.87-0.723 c0.293-0.233,0.651-0.39,0.96-0.581c0.351-0.141,0.661-0.318,1.007-0.419c0.331-0.12,0.656-0.221,0.974-0.293 c0.309-0.091,0.619-0.13,0.891-0.188c0.174-0.025,0.336-0.046,0.488-0.065c-0.018,0.046-0.035,0.09-0.054,0.136 c-0.158,0.433-0.28,0.888-0.367,1.367c-0.038,0.243-0.071,0.49-0.096,0.741c-0.02,0.255-0.024,0.519-0.006,0.797 c0.26-0.099,0.497-0.213,0.723-0.336c0.218-0.127,0.431-0.259,0.634-0.394c0.402-0.277,0.764-0.578,1.094-0.901 c0.662-0.642,1.211-1.358,1.674-2.13l0.058-0.096C20.618,3.882,20.585,3.255,20.204,2.806z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "26.308,25.118 26.308,22.884 30.51,22.884 30.51,21.36 26.308,21.36 26.308,19.549 30.883,19.549 30.883,18.024  24.54,18.024 24.54,26.648 31.086,26.648 31.086,25.118 \t\t"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "23.713,28.511 23.713,27.784 20.793,27.784 20.794,31.891 21.651,31.891 21.651,30.164 23.456,30.164  23.456,29.437 21.651,29.437 21.651,28.511 \t\t"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M22.698,24.7c0-1.61-0.383-1.876-1.092-2.188c0.854-0.287,1.334-1.106,1.334-2.053c0-0.746-0.422-2.438-2.717-2.438 h-4.358v8.624h1.768v-3.378h1.861c1.332,0,1.404,0.457,1.404,1.636c-0.001,0.887,0.072,1.333,0.193,1.744h1.992v-0.229 C22.698,26.274,22.698,25.961,22.698,24.7z M19.744,21.817h-2.111V19.51h2.244c1.059,0,1.262,0.672,1.262,1.129 C21.138,21.491,20.681,21.816,19.744,21.817z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "25.13,31.161 25.13,30.101 27.13,30.101 27.13,29.374 25.13,29.374 25.13,28.511 27.308,28.511 27.308,27.785  24.29,27.785 24.29,31.888 27.405,31.888 27.405,31.161 \t\t"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M31.356,30.962c0-0.767-0.185-0.892-0.521-1.039c0.407-0.139,0.637-0.526,0.637-0.979c0-0.352-0.201-1.16-1.293-1.16 h-2.074v4.103h0.842v-1.605h0.885c0.633,0,0.67,0.216,0.67,0.777c0,0.424,0.033,0.635,0.09,0.828h0.947V31.78 C31.357,31.713,31.357,31.565,31.356,30.962z M29.951,29.594h-1.004v-1.1h1.066c0.504,0,0.602,0.32,0.602,0.537 C30.615,29.438,30.398,29.594,29.951,29.594z"
})));

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M19.062,29.553l-0.998-0.246c-0.172-0.039-0.437-0.108-0.437-0.428c0-0.373,0.392-0.492,0.715-0.492 c0.75,0,0.816,0.437,0.843,0.617h0.819c-0.006-0.502-0.342-1.326-1.601-1.326c-1.331,0-1.575,0.808-1.575,1.265 c0,0.903,0.639,1.051,1.303,1.205l0.438,0.104c0.437,0.104,0.744,0.188,0.744,0.508c0,0.436-0.453,0.531-0.856,0.531 c-0.75,0-0.865-0.435-0.871-0.662h-0.818c0,0.508,0.256,1.371,1.754,1.371c0.358,0,1.617-0.109,1.617-1.343 C20.138,29.92,19.625,29.69,19.062,29.553z"
})));

var _ref12 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 12.381,
  y: 18.02,
  width: 1.801,
  height: 8.624
})));

var _ref13 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M10.849,27.786H9.858L8.395,31.89h0.904l0.285-0.846h1.514l0.264,0.846h0.932L10.849,27.786z M9.814,30.336l0.527-1.623 h0.007l0.512,1.623H9.814z"
})));

var _ref14 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "15.35,27.786 15.35,30.645 15.34,30.645 13.709,27.786 12.807,27.786 12.807,31.89 13.606,31.89 13.606,28.964  13.618,28.964 15.292,31.89 16.151,31.89 16.151,27.786 \t\t"
})));

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var _ref25 =
/*#__PURE__*/
React.createElement("g", null);

var _ref26 =
/*#__PURE__*/
React.createElement("g", null);

var _ref27 =
/*#__PURE__*/
React.createElement("g", null);

var _ref28 =
/*#__PURE__*/
React.createElement("g", null);

var _ref29 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      "enableBackground": "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

export default __webpack_public_path__ + "static/media/wire-transfer-logo.32ecf1be.svg";
export { SvgComponent as ReactComponent };